import { render, staticRenderFns } from "./PostBySourcesHero.vue?vue&type=template&id=3019783c&scoped=true&"
import script from "./PostBySourcesHero.vue?vue&type=script&lang=js&"
export * from "./PostBySourcesHero.vue?vue&type=script&lang=js&"
import style0 from "./PostBySourcesHero.vue?vue&type=style&index=0&id=3019783c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019783c",
  null
  
)

export default component.exports